{
    "grid-border-color": "#eac3c8",
    "grid-header-bg-color": "#c4455e",
    "grid-header-font-color": "#ffffff",
    "grid-cell-text-align": "left",
    "grid-row-hover-bg-color": "#f8d6db",
    "grid-row-active": "#d86378",
    "grid-row-alternate": "#faecee",
    "grid-footer-bg-color": "#b33c51",
    "grid-footer-font-color": "#ffffff",
    "grid-cell-font-color": "#541c28",
    "grid-checkbox-bg-color": "#c4455e",
    "tile-border-color": "#eac3c8",
    "tile-bg-color": "#c4455e",
    "tile-font-color": "#ffffff",
    "tile-hover-bg-color": "#b33c51",
    "header-bg-color": "#c4455e",
    "header-ico-active-color": "#b33c51",
    "title-font-color": "#c4455e",
    "login-ico-color": "#c4455e",
    "button-primary-bg-color": "#c4455e",
    "button-primary-hover-bg-color": "#b33c51",
    "button-secondary-bg-color": "#005086",
    "button-secondary-hover-bg-color": "#003d66",
    "button-secondary-font-color": "#ffffff",
    "object-ico-color": "#c4455e",
    "object-ico-active-color": "#b33c51"
}
